import { Outlet } from 'react-router-dom';
import { Sidebar, SidebarInner } from './Sidebar';
import { NotificationsPanel } from '../notifications/NotificationsPanel';
import { useState } from 'react';
import { Bell, Menu, Flame } from 'lucide-react';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';

export function Layout() {
  const [showNotifications, setShowNotifications] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="app-container">
      <Sidebar />

      <main className="main-content ml-0 md:ml-64 min-h-screen bg-background">
        {/* Top bar */}
        <header className="sticky top-0 z-40 h-16 border-b border-border bg-background/80 backdrop-blur-sm flex items-center justify-between md:justify-end px-4 sm:px-6">
          {/* Mobile: hamburger + brand */}
          <div className="flex items-center gap-2 md:hidden">
            <Sheet open={mobileNavOpen} onOpenChange={setMobileNavOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" data-testid="mobile-nav-toggle" aria-label="Open menu">
                  <Menu className="w-6 h-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="left" className="p-0 w-72 bg-[#020408] border-r border-white/5" data-testid="mobile-nav-drawer">
                <SidebarInner onNavigate={() => setMobileNavOpen(false)} />
              </SheetContent>
            </Sheet>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-orange-500 to-red-600 flex items-center justify-center">
                <Flame className="w-4 h-4 text-white" />
              </div>
              <span className="font-bold text-base"><span className="text-orange-500">Hot</span>forge</span>
            </div>
          </div>

          <Button
            variant="ghost"
            size="icon"
            onClick={() => setShowNotifications(!showNotifications)}
            data-testid="notifications-toggle"
            className="relative"
          >
            <Bell className="w-5 h-5" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-primary rounded-full" />
          </Button>
        </header>

        {/* Main content */}
        <div className="p-4 sm:p-6 lg:p-8">
          <Outlet />
        </div>

        {/* Notifications panel */}
        {showNotifications && (
          <NotificationsPanel onClose={() => setShowNotifications(false)} />
        )}
      </main>
    </div>
  );
}
